import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import PropTypes from 'prop-types';

const ConfigureStoreWrapper = ({ storeName, storeID }) => {
  const linkToV2Store = `/settings/stores/${storeID}`;
  return (
    <React.Fragment>
      <FormattedMessage
        defaultMessage='The store <a>{storeName}</a> has not been fully configured with messaging and company information. Completing this information will ensure that your packing slips and labels are produced properly.'
        description='alertConfigureStore.configBeginning'
        id='VeYHGP'
        values={{
          storeName,
          a: (chunks) => <a href={linkToV2Store}>{chunks}</a>,
        }}
      />
    </React.Fragment>
  );
};

ConfigureStoreWrapper.propTypes = {
  storeName: PropTypes.string.isRequired,
  storeID: PropTypes.string.isRequired,
};

export const ConfigureStore = injectIntl(ConfigureStoreWrapper);
